<!-- table skeleton loader -->
<div *ngIf="isFetchingUpdateDetails$ | async" class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>

<!-- Client Table -->
@if (!(isFetchingUpdateDetails$ | async)) {
  <div
    class="mt-[0.94rem] rounded-lg border border-solid border-gray-200 bg-white"
  >
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <div
          class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
        >
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-4 text-left text-xs font-semibold text-gray-600"
                >
                  S/N
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                      stroke="#667085"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </th>
                @if (hasJointAccount()) {
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Profile Number
                </th>
                }
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Field Name
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Old Value
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  New Value
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Section
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Profile
                </th>
              </tr>
            </thead>
            <tbody>
              @for (
                update of updateDetails$ | async;
                track update.id;
                let i = $index
              ) {
                <tr>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p>{{ i + 1 }}</p>
                  </td>
                  @if (hasJointAccount()) {
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ getProfileNumber(update) || '-' }}
                    </p>
                  </td>
                  }
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ (update.column_name | uppercase) || '-' }}
                    </p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ getValue(update, 'old_value') || '-' }}
                    </p>
                  </td>

                  <td
                    class="border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                  >
                     {{ getValue(update, 'new_value') || '-' }}
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                  >
                     {{ (update.table_name | camelToTitle) || '-' }}
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                  >
                     {{ getEditedBy() }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <!-- <app-table-navigator
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        ></app-table-navigator> -->
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4 flex flex-col items-end gap-2">
    <div class="flex gap-2">
      <button
        mango-button
        class="w-fit shrink-0 items-center"
        (click)="updateAction('approved')"
        [disabled]="overallStatus == 'approved'"
      >
        Approve
      </button>

      <button
        mango-button
        class="w-fit shrink-0 items-center"
        (click)="updateAction('rejected')"
        [disabled]="overallStatus == 'rejected'"
      >
        Reject
      </button>
    </div>

    <!-- Status Message -->
    <div *ngIf="overallStatus !== 'pending'"
        class="text-sm mt-2 font-semibold"
        [style.color]="overallStatus === 'approved' ? '#0A756F' : overallStatus === 'rejected' ? '#F4361C' : 'inherit'">
      {{ overallStatus === 'approved' ? 'This update has been APPROVED' : overallStatus === 'rejected' ? 'This update has been REJECTED' : '' }}
    </div>
  </div>

}
